import ImagesConfigInterface from 'interfaces/ImagesConfigInterface';

const getImageDomain = (locale: string, config: ImagesConfigInterface | null): string => {
    if (!config) {
        return '';
    }

    if (locale === 'ru' && process.env.NODE_ENV === 'production') {
        return config.img_domain_egabe;
    }

    return config.img_domain;
};

export default getImageDomain;
